import React, { useState, useEffect } from "react"
import {Row, Col} from 'antd/lib/index'
import './HeaderLayout.less'
import {BackTop} from "antd";
import {ToTopOutlined} from "../icons";

function HeaderLayout(props) {
    const [title, setTitle] = useState('国际胸腔镜手术视频大赛')

    useEffect(() => {
        let basename = location.pathname.match(/^\/[^\/]*/g)[0]
        if (basename === '/lsvc' || basename === '/') {
            document.title = 'AME-Medtronic 胸腔镜手术视频大赛'
        } else if (basename === '/xwxr') {
            document.title = '胸外新瑞中国胸外科病例演讲大赛'
            setTitle('胸外新瑞中国胸外科病例演讲大赛')
        }
    }, [])

    function gotoHome() {
        props.history.push("/home")
    }

    return (
        <div className="header_layout">
            <Row className="header_row" type="flex" align="middle">
                <Col>
                    <div className="header_wrapper">
                        <div className="header_left">
                            <div className="header_home" onClick={() => {
                                gotoHome()
                            }}>
                                {title}
                            </div>
                        </div>
                        <div className="header_right">
                            <div className="header_logo">
                                <a href={"http://www.amegroups.com/"} target="_blank">
                                    <img
                                        src="http://fp.amegroups.cn/cms/db850562b889fd39e985dbd85950b34a.png?x-oss-process=image/auto-orient,1/interlace,1/resize,m_lfit,w_300/quality,q_100"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="header_back_top">
                        <BackTop>
                            <div className="back_top">
                                <ToTopOutlined  style={{fontSize: '32px', color: '#fff'}}/>
                            </div>
                        </BackTop>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default HeaderLayout
